<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Vvm4m8/tc-custom/9781488059490.jpg?1728155802942" alt="This image is the cover for the book Crowning His Unlikely Princess"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crowning His Unlikely Princess
      </h1>
      <p class="bookDescription body article font2">
        <b>When her aristocratic boss is next in line for the throne, a personal assistant wonders if the attraction between them will turn her into his royal wife. </b><br/><br/>He never expected to rule . . . <br/><br/>She never expected to be his bride!<br/><br/>Prince Logan wasn’t destined to wear the crown, and he certainly doesn’t want it! But his brother’s scandalous abdication leaves him no choice. After returning home, he assumes that loyal assistant Cassidy Ryan will remain by his side.<br/><br/>Cassidy’s life has been turned upside down by her boss’s shocking announcement. She doesn’t know the first thing about organizing a royal diary . . . or how to handle the thrilling desire Prince Logan has suddenly awakened! But when Logan reveals he craves her, too, Cassidy must decide: could she really be his princess?<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michelle Conder
      </h2>
      
      <p class="authorDescription body article">From as far back as she can remember Michelle Conder dreamed of being a writer. She penned the first chapter of a romance novel just out of high school, but it took much study, many (varied) jobs, one ultra-understanding husband and three gorgeous children before she finally sat down to turn that dream into a reality.  Michelle lives in Australia, and when she isn’t busy plotting she loves to read, ride horses, travel and practise yoga. Visit Michelle: www.michelleconder.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c7bfd22